import MarkdownIt from 'markdown-it'
import DOMPurify from 'dompurify'
const md = new MarkdownIt({
  breaks: true,
  linkify: true,
  html: false
})
md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  if (env?.preview) return ''
  const token = tokens[idx]
  const hrefIndex = token.attrIndex('href')
  const href = hrefIndex >= 0 ? token.attrs[hrefIndex][1] : ''
  if (hrefIndex >= 0) token.attrs.splice(hrefIndex, 1)
  token.tag = 'button'
  token.attrPush(['type', 'button'])
  if (href) token.attrPush(['data-url', href])
  token.attrPush(['class', 'markdown-btn'])
  if (href && env && Array.isArray(env.links)) {
    const nextToken = tokens[idx + 1]
    const text = nextToken && nextToken.type === 'text' ? nextToken.content : href
    env.links.push({ href, text })
  }
  return self.renderToken(tokens, idx, options)
}

md.renderer.rules.link_close = (tokens, idx, options, env, self) => {
  if (env?.preview) return ''
  tokens[idx].tag = 'button'
  return self.renderToken(tokens, idx, options)
}

/**
 * 
 * @param {string} text 
 * @param {Object} options
 * @param {boolean} options.preview 
 * @returns {Object} { html: string, links: Array<{href, text}> } Estructura de salida
 */
export function parseMarkdown(text) {
  if (!text) return { html: '', links: [] }
  const env = { preview: true, links: [] }
  const tokens = md.parse(text, env)
  removeLinksFromTokens(tokens)
  const rawHtml = md.renderer.render(tokens, md.options, env)
  const linkEnv = { preview: false, links: [] }
  md.render(text, linkEnv)
  return {
    html: DOMPurify.sanitize(rawHtml),
    links: linkEnv.links
  }
}
function removeLinksFromTokens(tokens) {
  for (const token of tokens) {
    if (token.type === 'inline' && Array.isArray(token.children)) {
      const out = []
      let skipDepth = 0
      for (let i = 0; i < token.children.length; i++) {
        const t = token.children[i]
        if (t.type === 'link_open') { skipDepth++; continue }
        if (t.type === 'link_close') { if (skipDepth > 0) skipDepth--; continue }
        if (skipDepth > 0) continue
        out.push(t)
      }
      token.children = out
    }
    if (token.children && token.type !== 'inline') removeLinksFromTokens(token.children)
  }
}
